type CacheTimeout = NodeJS.Timeout | number;

export class TimeDrivenCache<CacheKey = string, CacheValue = unknown> {
  private readonly lifetime: number;
  private readonly items: Map<CacheKey, { value: CacheValue; timeout: CacheTimeout }>;

  constructor({ lifetime }: { lifetime: number }) {
    this.lifetime = lifetime;
    this.items = new Map();
  }

  clearItem({ key }: { key: CacheKey }): void {
    this.clearTimeout({ key });
    this.items.delete(key);
  }

  destroy(): void {
    this.items.forEach((_, key) => this.clearItem({ key }));
  }

  hasItem({ key }: { key: CacheKey }): boolean {
    return this.items.has(key);
  }

  getItem({ key }: { key: CacheKey }): CacheValue | undefined {
    return this.items.get(key)?.value;
  }

  setItem({ key, value }: { key: CacheKey; value: CacheValue }): CacheValue {
    this.clearTimeout({ key });
    this.items.set(key, { value, timeout: this.setTimeout({ key }) });
    return value;
  }

  private clearTimeout({ key }: { key: CacheKey }): void {
    clearTimeout(this.getTimeout({ key }));
  }

  private getTimeout({ key }: { key: CacheKey }): CacheTimeout | undefined {
    return this.items.get(key)?.timeout;
  }

  private setTimeout({ key }: { key: CacheKey }): CacheTimeout {
    return setTimeout(() => this.clearItem({ key }), this.lifetime);
  }
}
